(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntitySelectorDialogCtrl', EntitySelectorDialogCtrl);

    EntitySelectorDialogCtrl.$inject = [
        '$q',
        '$scope',
        'DialogInstance',
        'pageHeading',
        'EntitiesService',
        'SystemService',
        'entityTemplate',
        'loadUserEntities',
        'multiSelectMode'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting one or more entities from an entities grid, utilising paging and search functionality.
     */
    function EntitySelectorDialogCtrl(
        $q,
        $scope,
        DialogInstance,
        pageHeading,
        EntitiesService,
        SystemService,
        entityTemplate,
        loadUserEntities,
        multiSelectMode) {

        /* jshint validthis:true */
        var vm = this;
        vm.entityTemplate = entityTemplate;
        vm.pageHeading = pageHeading;
        vm.entities = [];
        vm.allEntitiesSelected = false;
        vm.entityCount = 0;
        vm.currentPage = 1;
        vm.searchText = '';
        vm.listPageSize = 10;
        vm.loading = false;
        vm.error = null;
        vm.orderFields = [{ Name: 'updated_date', Order: 'desc' }];
        vm.updateList = updateList;
        vm.selectedOrderFieldChange = selectedOrderFieldChange;
        vm.orderSelectorDisabled = orderSelectorDisabled;
        vm.entitySelected = entitySelected;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'selectedEntityIds', { get: getSelectedEntityIds });
        Object.defineProperty(vm, 'searchLabel', { get: getSearchLabel });

        activate();

        function activate() {
            $scope.$watchCollection('vm.searchText', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    updateList(1);
                }
            });

            vm.searchDelay = SystemService.getSearchDelay();
            vm.orderOptions = _.map(entityTemplate.OrderSetting.Options, function (orderOption) {
                return { value: orderOption.Name, label: orderOption.Name };
            });

            if (entityTemplate.OrderSetting.Default !== '') {
                vm.selectedOrderOption = entityTemplate.OrderSetting.Default;
            } else {
                vm.selectedOrderOption = entityTemplate.OrderSetting.Options[0].Name;
            }

            vm.selectedOrderFieldChange();
        }

        /**
         * Update the list of entities which are to be shown for the current page.
         *
         * @param {int} newPage - If supplied, it will be used to set the current page value before the list is updated. Optional.
         */
        function updateList(newPage) {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            if (!angular.isUndefined(newPage)) {
                vm.currentPage = newPage;
            }

            // Search all fields using the same text input
            var searchFields = [];
            if (!_.isNil(entityTemplate) && !_.isNil(entityTemplate.SearchFields)) {
                angular.forEach(entityTemplate.SearchFields, function (searchFieldKey) {
                    searchFields[searchFieldKey] = vm.searchText;
                });
            }

            vm.loading = true;

            var getEntitiesQueryParameters = {
                pageSize: vm.listPageSize,
                currentPage: vm.currentPage,
                searchFields: searchFields,
                orderFields: vm.orderFields,
                skipSecurity: true,
                previewTextOnly: true
            };

            if (loadUserEntities) {
                getEntitiesQueryParameters.EntityType = 'User';
            }

            getEntitiesQueryParameters.entityTemplateId = entityTemplate.Id;

            var getPromise = EntitiesService.query(getEntitiesQueryParameters)
                .then(getEntitiesOk, getEntitiesError)
                .then(function () {
                    vm.loading = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEntitiesOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.allEntitiesSelected = false;
                    vm.entities = data.Entities;
                    vm.entityCount = data.EntitiesCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getEntitiesError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * Update the ordering fields and then update the entities list.
         */
        function selectedOrderFieldChange() {
            updateOrderFields();
            updateList();
        }

        /**
         * Update the ordering fields to be those of the currently selected order option.
         */
        function updateOrderFields() {
            var currentOrderOption = _.find(entityTemplate.OrderSetting.Options, function (n) { return n.Name === vm.selectedOrderOption; });

            if (!angular.isUndefined(currentOrderOption) && currentOrderOption !== null) {
                vm.orderFields = currentOrderOption.Fields;
            }
        }

        function orderSelectorDisabled() {
            var result = true;

            if (!angular.isUndefined(entityTemplate) && entityTemplate !== null && !angular.isUndefined(entityTemplate.OrderSetting) && entityTemplate.OrderSetting.Options.length > 1) {
                result = false;
            }

            return result;
        }

        /**
         * Get a list of entity ids for the entities which are currently selected (checkbox).
         *
         * @returns {array} Returns an array of entity ids.
         */
        function getSelectedEntityIds() {
            var selectedEntityIds = [];

            angular.forEach(_.filter(vm.entities, function (entity) {
                return entity.Selected;
            }), function (selectedEntity) {
                selectedEntityIds.push(selectedEntity.Id);
            });

            return selectedEntityIds;
        }

        /**
         * Get the label, based on entity template, to use for the "Search" field.
         *
         * @returns {string}
         */
        function getSearchLabel() {
            var searchLabel = '';

            if (!_.isNil(entityTemplate) && !_.isNil(entityTemplate.SearchFields) && entityTemplate.SearchFields.length > 0) {
                if (entityTemplate.SearchFields.length > 1) {
                    searchLabel = ' or ' + entityTemplate.SearchFields[entityTemplate.SearchFields.length - 1];
                }

                for (var i = entityTemplate.SearchFields.length - 2; i > 0; i--) {
                    searchLabel = ', ' + entityTemplate.SearchFields[i] + searchLabel;
                }

                searchLabel = 'Search by ' + entityTemplate.SearchFields[0] + searchLabel;
            }

            return searchLabel;
        }

        /**
         * Operations to happen when an entity is selected in the list.
         * If multi select mode is not enabled, all entities apart from the one provided will be deselected.
         *
         * @param {object} - Entity which was just selected.
         */
        function entitySelected(selectedEntity) {
            if (!multiSelectMode) {
                angular.forEach(vm.entities, function (entity) {
                    if (entity !== selectedEntity) {
                        entity.Selected = false;
                    }
                });
            }
        }

        function ok() {
            DialogInstance.ok(vm.selectedEntityIds);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
